import React from "react";
import type { Team } from "../types/team";
export function TeamLetter({
  team
}: {
  team: Team;
}) {
  const isTrio = team.members.length === 3;
  return <>
      <div className="flex items-baseline justify-between" data-id="element-709" data-mp="2zm1aaq41uvz6">
        <p className="text-sm font-semibold sm:text-base" data-id="element-710" data-mp="34gf7my29vd6h">Team {team.id}</p>
        <p className="text-xs text-navy/60 sm:text-sm" data-id="element-711" data-mp="39egqbhvsdahf">{isTrio ? "Trio" : "Pair"}</p>
      </div>
      <ul className={`mt-2 border-t border-navy/10 pt-2 ${isTrio ? "space-y-0.5" : "space-y-1.5"}`} data-id="element-712" data-mp="2br8b24mdoxnv">
        {team.members.map(m => {
        const isLink = m.school === "link";
        return <li key={m.name} className="flex items-baseline justify-between gap-3" data-id="element-713" data-mp="2locx84g84t4o">
              <span className={`truncate font-bold tracking-tight ${isTrio ? "text-lg sm:text-xl" : "text-xl sm:text-2xl"}`} data-id="element-714" data-mp="2qo8snfauvc8m">
                {m.name}
              </span>
              <span className={`shrink-0 text-xs font-semibold ${isLink ? "text-brgreen" : "text-saffron-dark"}`} data-id="element-715" data-mp="10q7m98umwfn">
                {isLink ? "LINK · Brazil" : "Mahindra · India"}
              </span>
            </li>;
      })}
      </ul>
    </>;
}